import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
//import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
//import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import SelectUser from '../../../Components/shared/SelectUser';
import { PeriodeDashboard } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriode } from '../DashbordBackOffice';
import { listStautAO } from './InterfacesDashboards';

function CandidaturesParAo({DataForCandidatureRecuParAO,filtreClient,height,width,role}){

    CandidaturesParAo.propTypes = {
        DataForCandidatureRecuParAO: PropTypes.any,
        filtreClient: PropTypes.any,
        height:PropTypes.any,
        width:PropTypes.any,
        role:PropTypes.any,
    };

    const [chartData, setChartData] = useState({
        options: {
            chart: {
                type: 'bar',
                zoom: {
                    enabled: true,
                },
            },
            bar : {
                columnWidth: '20px',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    distributed: true, // this line is mandatory
                    columnWidth: '15%', // Set the desired bar width as a percentage of the available space
                    //colors: ['#FADC19', '#165DFF'], // Assign colors to bars
                }
            },
            stroke: {
                show: true,
                colors: ['transparent'],
                width: 2,
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false, // Show t-he legend
                position: 'bottom',
                fontSize: '10px',
                customLegendItems: ['AO cloturé', 'AO ouvert'],
                markers: {
                    fillColors: ['#FADC19', '#165DFF'], //Assign colors to marker symbols
                },
                offsetY: 0 // Moves the legend 40 pixels down from its default position
            },
            fill: {
                opacity: 1,
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
        },
        series: []

    });
    const [customDateRange, setCustomDateRange] = useState({});
    const [selectedSource, setSelectedSource] = useState(['ao']);
    const [selectedClientvalue,setSelectedClientvalue] = useState('all');// Default selected client
    const [filtreAOStatuts, setFiltreAOStatuts] = useState('open');
    //const [candidatureNotEqZero,setCandidatureNotEqZero] =useState('notEqZero');
    const [selectedPeriod, setSelectedPeriod] = useState('thisMonth'); // Default selected period
    const { inputSize } = useWindowSize();
    const { i18n } = useTranslation();
    const widthFiltre = role === 'client' ? '33.33%' : '25%';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const source =[
        {
            label:'Ao',
            value:'ao'
        },
        {
            label:'Cvtheque',
            value:'cvtheque'
        }

    ];

    const getInfosFromList = (filteredList) => {
        const groupedData = {};

        //Group items by month-year and filter out items with candidature_count of 0
        filteredList.forEach(item => {
            if(item.candidature_count !== 0){
                const [year, month] = item.dateDebutAO.split('T')[0].split('-');
                const monthYear = `${month}-${year}`;
                if (!groupedData[monthYear]) {
                    groupedData[monthYear] = [];
                }
                groupedData[monthYear].push(item);
            }
        });

        // Get unique categories (month-year) from groupedData
        const categories = Object.keys(groupedData).map(monthYear => monthYear);
        let res=[];
        filteredList.forEach(item => {
            let temp=[];
            const [year, month] = item.dateDebutAO.split('T')[0].split('-');
            const monthYear = `${month}-${year}`;
            categories.forEach(item2 => {
                // Check if item has candidature_count and it's a valid number
                const count = (item2 === monthYear && typeof item.candidature_count === 'number')
                    ? item.candidature_count
                    : 0;
                temp.push(count);
            });

            res.push({name:item.intitulePoste,data:temp});
        });
        return {res,categories};
    };

    useEffect(() => {
        var filteredData;
        if(DataForCandidatureRecuParAO && Array.isArray(DataForCandidatureRecuParAO) && DataForCandidatureRecuParAO.length > 0){
            filteredData=DataForCandidatureRecuParAO;
            if(filtreClient){
                if (selectedClientvalue != 'all') {
                    filteredData = DataForCandidatureRecuParAO.filter(
                        (item) => item.companyDataId == selectedClientvalue
                    );
                }
            }

            if(filtreAOStatuts!='all')
                filteredData = filteredData.filter(
                    (item) => filtreAOStatuts==item.status
                );

            if(selectedSource)
                filteredData = filteredData.filter(
                    (item) => selectedSource.includes(item.type)
                );

            filteredData=filtreListPeriode(filteredData,selectedPeriod,customDateRange);

            const {res,categories} = getInfosFromList(filteredData);

            setChartData((prevState) => {
                console.log('Series Data:', res,'categories',categories);
                const colors = res.map(item => item.fillColor);
                //console.log('Series Data:', seriesData,'categories',categories);
                console.log('colors',colors);
                return {
                    ...prevState,
                    series: res,
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            //type: 'date',
                            type: 'category', // Use category type for x-axis
                            categories:categories
                        },
                        yaxis: {
                            ...prevState.options.yaxis,
                            min: 0, // Set the minimum value for the y-axis to 0
                            max: Math.max(...res.map(item => Math.max(...item.data))), // Set the maximum value based on the maximum value in the data
                        }
                        //tooltip: {
                        //    ...prevState.options.tooltip,
                        //    x: {
                        //        formatter: function(val) {
                        //            return 'Q' + dayjs(val).quarter() + ' ' + dayjs(val).format('YYYY')
                        //        }
                        //    }
                        //},

                    },
                    //colors: colors
                };
            });
        }
    },[selectedPeriod,selectedSource,customDateRange,filtreAOStatuts,selectedClientvalue,DataForCandidatureRecuParAO]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Total candidatures')}</h1>
                <div className='filtre1' >
                    <div style={{width:widthFiltre}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeDashboard}

                        />
                    </div>
                    {filtreClient &&
                        <div style={{width:'25%'}}>
                            <SelectUser
                                selectedClientvalue={selectedClientvalue}
                                setSelectedClientvalue={setSelectedClientvalue}
                            />
                        </div>
                    }
                    <div style={{width:widthFiltre}}>
                        <SelectComponent
                            label={i18n.t('Statut besoin')}
                            val={filtreAOStatuts}
                            name='StatutAO'
                            setVal={(e) => {
                                setFiltreAOStatuts(e.target.value);
                            }}
                            listVal={listStautAO}
                        />
                    </div>
                    <div style={{width:'25%'}}>
                        <ThemeProvider theme={FieldComponentFont}>
                            <FormControl style={{width:'100%'}}>
                                <InputLabel
                                    shrink={true}
                                >{i18n.t('source')} </InputLabel>
                                <Select
                                    labelId="source"
                                    id="source"
                                    label={i18n.t('source')}
                                    multiple
                                    value={selectedSource}
                                    onChange={(event)=>{
                                        const {
                                            target: { value },
                                        } = event;
                                        console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                        setSelectedSource(
                                        // On autofill we get a stringified value.
                                            typeof value === 'string' ? value.split(',') : value,
                                        );
                                    }}
                                    size={inputSize}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px' },
                                    }}
                                    style={{ width: '100%', background: 'white' }}
                                    input={<OutlinedInput label="Clients" />}
                                    renderValue={(selected) => {
                                        return selected
                                            .map((val) => {
                                                const selectedOption = source.find(
                                                    (element) => element.value === val
                                                );
                                                return i18n.t(selectedOption?.label);
                                            })
                                            .join(', ');
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    {Array.isArray(source) && source?.map((element) => (
                                        <MenuItem
                                            key={element.value}
                                            value={element.value}
                                        >
                                            <Checkbox checked={selectedSource.includes(element.value)} />
                                            <ListItemText primary={i18n.t(element.label)} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </div>

                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartData.options}
                        series={chartData.series}
                        type="bar"
                        height={'85%'}
                        width={'100%'}
                    />
                </div>
            </div>
        </>
    );

}

export default CandidaturesParAo;